import type { ExactIntegerResponse } from '../learningEngineV2/batchContract';

export type MathAnswerDraftV2 = {
  rawValue: string;
  response: ExactIntegerResponse | null;
  firstInteractedAt?: string;
  lastEditedAt?: string;
};

export type MathAnswerDraftMapV2 = Record<string, MathAnswerDraftV2>;

export function normalizeIntegerAnswerInput(value: string): string {
  const compact = value.replace(/\s+/g, '').replace(/[^0-9-]/g, '');
  const negative = compact.startsWith('-');
  const digits = compact.replace(/-/g, '');
  return `${negative ? '-' : ''}${digits}`;
}

export function exactIntegerResponseFromRaw(rawValue: string): ExactIntegerResponse | null {
  if (!/^-?\d+$/.test(rawValue)) return null;
  const value = Number(rawValue);
  if (!Number.isSafeInteger(value)) return null;
  return { type: 'integer', value };
}

export function updateMathAnswerDraft(
  current: MathAnswerDraftV2 | undefined,
  nextRawValue: string,
  atIso: string,
): MathAnswerDraftV2 {
  const rawValue = normalizeIntegerAnswerInput(nextRawValue);
  return {
    rawValue,
    response: exactIntegerResponseFromRaw(rawValue),
    firstInteractedAt: current?.firstInteractedAt ?? atIso,
    lastEditedAt: atIso,
  };
}

export function isMathAnswerReady(draft: MathAnswerDraftV2 | undefined): draft is MathAnswerDraftV2 & { response: ExactIntegerResponse } {
  return Boolean(draft?.response);
}
